import { FormEvent, useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

type Msg = {
  id: number;
  from_user: number;
  to_user: number;
  from_name: string;
  to_name: string;
  message: string;
  created_at: string;
};

export default function ChatBody() {
  const { user } = useAuth();
  const [messages, setMessages] = useState<Msg[]>([]);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const feedRef = useRef<HTMLDivElement>(null);

  async function refresh() {
    try {
      const r = await api.get<{ messages: Msg[] }>('/chat');
      setMessages(r.messages);
    } catch {
      /* noop */
    }
  }

  useEffect(() => {
    refresh();
    const iv = setInterval(refresh, 15_000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (feedRef.current) feedRef.current.scrollTop = feedRef.current.scrollHeight;
  }, [messages.length]);

  async function send(e: FormEvent) {
    e.preventDefault();
    if (!draft.trim()) return;
    setBusy(true);
    try {
      await api.post('/chat', { message: draft.trim() });
      setDraft('');
      await refresh();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="chat-body">
      <div className="chat-feed" ref={feedRef}>
        {messages.length === 0 && (
          <div className="card-meta" style={{ padding: 12 }}>
            Aucun message. Démarrez la conversation.
          </div>
        )}
        {messages.map((m) => {
          const mine = m.from_user === user?.id;
          return (
            <div
              key={m.id}
              style={{
                display: 'flex',
                justifyContent: mine ? 'flex-end' : 'flex-start',
                marginBottom: 6,
              }}
            >
              <div
                style={{
                  maxWidth: '80%',
                  background: mine ? 'var(--c-sage)' : 'var(--c-nav)',
                  color: mine ? '#fff' : 'var(--c-text)',
                  padding: '8px 12px',
                  borderRadius: 12,
                  fontSize: 14,
                }}
              >
                {!mine && (
                  <div style={{ fontSize: 11, opacity: 0.7, marginBottom: 2 }}>{m.from_name}</div>
                )}
                {m.message}
              </div>
            </div>
          );
        })}
      </div>
      <form className="chat-foot" onSubmit={send}>
        <input
          placeholder="Message…"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          disabled={busy}
        />
        <button className="btn btn-primary" disabled={busy}>
          ↑
        </button>
      </form>
    </div>
  );
}
